// 天润统计
export function changeHeader(filetype, publishedtype, pagetype, catalogs) {
    let head = document.querySelectorAll('meta');
    head.forEach(element => {

        console.log(element.name + "--------------------" + element.content);
        if (element.name === "filetype") {
            element.content = filetype;
        }
        if (element.name === "publishedtype") {
            element.content = publishedtype;
        }
        if (element.name === "pagetype") {
            element.content = pagetype;
        }
        if (element.name === "catalogs") {
            element.content = catalogs;
        }

    });

}


// WEBPACK FOOTER //
// ./src/api/statistics/index.js